<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
  </div>
  <div class="row">
    <!-- SELECT TYPE DEAL -->
    <section class="col-12">
      <div class="card" [formGroup]="formGroupDetail">
        <!--TITLE-->
        <div class="card-title px-2 pt-2 mb-0 d-flex align-items-center">
          <h3 class="mr-075 mb-0">{{ "DETAIL_COMMISSION" | translate }}</h3>
        </div>
        <div class="card-body pb-0">
          <!--TYPE_SELECTION-->
          <div class="row">
            <div class="form-group col-xl-4 col-12">
              <label for="customer">{{ "CUSTOMER" | translate }}<sup class="text-danger">*</sup></label>
              <ng-select
                id="customer"
                bindLabel="name"
                bindValue="id"
                formControlName="customer"
                [multiple]="false"
                [searchable]="true"
                [closeOnSelect]="true"
                [readonly]="true"
                [clearable]="false"
                [openOnEnter]="false"
                [virtualScroll]="true"
                [items]="customersList"
              ></ng-select>
            </div>
            <div class="form-group col-xl-2 col-12">
              <label for="protocol">{{ "PROTOCOL" | translate }}<sup class="text-danger">*</sup></label>
              <input id="protocol" class="form-control" [(ngModel)]="currentCommission.protocol" [ngModelOptions]="{ standalone: true }" [readonly]="true" />
            </div>
            <div class="form-group col-xl-6 col-12">
              <label for="name">{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
              <input class="form-control" id="name" formControlName="name" [placeholder]="'PLACEHOLDER.INSERT_NAME' | translate" />
              <div class="invalid-feedback">{{ "ERRORS.FIELD_NAME" | translate }}</div>
            </div>
            <div class="form-group col-12">
              <label for="state" class="mr-075">{{ "STATE_COMMISSION" | translate }}: </label>
              <div id="state" class="badge badge-pill badge-{{ currentCommission.status === 0 ? 'success' : 'danger' }}">
                {{ currentCommission.status === 0 ? ("OPENED_FEMALE" | translate) : isClosingCommission(currentCommission.closed_date) ? ("CLOSING" | translate) : ("CLOSED_FEMALE" | translate) }}
              </div>
            </div>
            <div class="col-12" *ngIf="!!currentCommission.closed_date && currentCommission.status === 1">
              <label for="closed_date" class="mr-075">{{ "DATE" | translate }}: </label>
              <span id="closed_date">
                {{ _utilService.formatDate(currentCommission.closed_date) }}
              </span>
            </div>
            <div class="col-12" *ngIf="!!currentCommission.status_note && currentCommission.status === 1">
              <label for="note" class="mr-075">{{ "NOTE" | translate }}: </label>
              <span id="note">
                {{ currentCommission.status_note }}
              </span>
            </div>
          </div>
        </div>
        <div class="card-footer col-12 d-flex justify-content-between border-0">
          <button class="btn btn-outline-primary mr-1" (click)="modalOpen(closeCommissionModal, null)" *ngIf="currentCommission.status === 0 && _authService.hasCapability('edit_commission')">
            {{ "CLOSE_COMMISSION" | translate }}
          </button>
          <button class="btn btn-outline-primary mr-1" (click)="reOpenCommission()" *ngIf="currentCommission.status === 1 && _authService.hasCapability('edit_commission')">{{ "REOPEN_COMMISSION" | translate }}</button>
          <button class="btn btn-primary" (click)="editCommission()" *ngIf="!currentCommission.closed">{{ "EDIT_NAME" | translate }}</button>
        </div>
      </div>
    </section>
    <!--ADMINISTRATIVE DETAIL SECTION-->
    <section class="col-12" id="section2">
      <div class="card" [ngClass]="activeTab === 'orders' ? 'active pb-0' : ''">
        <!--TITLE-->
        <div class="card-title px-2 mb-0" (click)="changeTab('orders')">
          <h3>{{ "ADMINISTRATIVE_DETAIL" | translate }}</h3>
        </div>
        <div [ngClass]="activeTab === 'orders' ? 'card-body p-0' : 'd-none'" *ngIf="_utilService.isDesktop">
          <div class="row px-2 mb-1">
            <div class="col-12 text-right" *ngIf="_authService.hasCapability('create_order') && !currentCommission.closed">
              <button class="btn btn-outline-primary" (click)="modalOpen(detailOrder, null)">{{ "ADD_ROUND" | translate }}</button>
            </div>
          </div>
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            *ngIf="orderList && orderList.length > 0"
            [rowClass]="getRowClass"
            [rowHeight]="60"
            [limit]="10"
            [footerHeight]="50"
            [rows]="orderList"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
            [sorts]="[{ prop: 'progressive_id', dir: 'desc' }]"
          >
            <ngx-datatable-column [name]="'ROUND' | translate" [sortable]="false" [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span class="font-weight-bold">{{ row.progressive_id ? row.progressive_id : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'STATE' | translate" [sortable]="false" [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span class="badge badge-pill badge-{{ row?.status_order.color }}" [ngbTooltip]="row?.status_order?.closed_date ? row?.status_order?.closed_date : null">
                  {{ row?.status_order.label }}
                </span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'PRODUCTS' | translate" [sortable]="false" [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span class="text-break-line-1" [ngbTooltip]="row.products_names ? row.products_names : null">{{ row.products_names ? row.products_names : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'FROM' | translate" [sortable]="false" [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.from ? _utilService.formatDate(row.from) : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TO' | translate" [sortable]="false" [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.to ? _utilService.formatDate(row.to) : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CAPACITY' | translate" [sortable]="false" [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.capacity }} €</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'RESIDUE' | translate" [sortable]="false" [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.residue ? row.residue : '0,00' }} €</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex">
                  <button class="bg-transparent border-0 text-secondary pr-1">
                    <span (click)="modalOpen(detailOrder, row)" class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate" placement="left">
                      <i [data-feather]="'edit-2'" size="19"></i>
                    </span>
                  </button>
                  <button *ngIf="!currentCommission.closed" class="bg-transparent border-0 text-secondary pr-1">
                    <span (click)="deleteOrder(row.order_id)" class="text-danger text-center" [ngbTooltip]="'DELETE' | translate" placement="left">
                      <i [data-feather]="'trash-2'" size="19"></i>
                    </span>
                  </button>
                  <button *ngIf="!row.closed && !currentCommission.closed" class="bg-transparent border-0 text-secondary">
                    <span (click)="openModalCloseRound(closeRoundModal, row)" class="text-danger text-center" [ngbTooltip]="'CLOSE_ROUND' | translate" placement="left">
                      <i [data-feather]="'lock'" size="19"></i>
                    </span>
                  </button>
                  <button *ngIf="!!row.closed && !currentCommission.closed" class="bg-transparent border-0 text-secondary">
                    <span (click)="openModalCloseRound(closeRoundModal, row)" class="text-success text-center" [ngbTooltip]="'OPEN_ORDER' | translate" placement="left">
                      <i [data-feather]="'unlock'" size="19"></i>
                    </span>
                  </button>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
        <div [ngClass]="activeTab === 'orders' ? 'card-body pb-0' : 'd-none'" *ngIf="_utilService.isTablet || _utilService.isMobile">
          <div class="row" *ngIf="_authService.hasCapability('create_order')">
            <div class="col-12 text-center mb-1">
              <button class="btn btn-outline-primary" (click)="modalOpen(detailOrder, null)">{{ "ADD_ROUND" | translate }}</button>
            </div>
          </div>
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowClass]="getRowClass"
            [rowHeight]="300"
            [limit]="10"
            [footerHeight]="50"
            [rows]="orderList"
            *ngIf="orderList && orderList.length > 0"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
            [sorts]="[{ prop: 'progressive_id', dir: 'desc' }]"
          >
            <ngx-datatable-column [name]="'ROUND' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row">
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "ROUND" | translate }}: </span>
                    <span>{{ row.progressive_id ? row.progressive_id : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "STATE" | translate }}: </span>
                    <span class="badge badge-pill badge-{{ row?.status_order.color }}" [ngbTooltip]="row?.status_order?.closed_date ? row?.status_order?.closed_date : null">
                      {{ row?.status_order.label }}
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "PRODUCTS" | translate }}: </span>
                    <span class="text-break-line-1" [ngbTooltip]="row.products_names ? row.products_names : null">{{ row.products_names ? row.products_names : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "FROM" | translate }}: </span>
                    <span>{{ row.from ? _utilService.formatDate(row.from) : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "TO" | translate }}: </span>
                    <span>{{ row.to ? _utilService.formatDate(row.to) : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "CAPACITY" | translate }}: </span>
                    <span>{{ row.capacity }} €</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "RESIDUE" | translate }}: </span>
                    <span>{{ row.residue }} €</span>
                  </div>
                  <div class="col-12 d-flex justify-content-end">
                    <button class="bg-transparent border-0 text-secondary pr-1">
                      <span (click)="modalOpen(detailOrder, row)" class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate" placement="left">
                        <i [data-feather]="'edit-2'" size="19"></i>
                      </span>
                    </button>
                    <button *ngIf="!currentCommission.closed" class="bg-transparent border-0 text-secondary pr-1">
                      <span (click)="deleteOrder(row.order_id)" class="text-danger text-center" [ngbTooltip]="'DELETE' | translate" placement="left">
                        <i [data-feather]="'trash-2'" size="19"></i>
                      </span>
                    </button>
                    <button *ngIf="!row.closed && !currentCommission.closed" class="bg-transparent border-0 text-secondary">
                      <span (click)="openModalCloseRound(closeRoundModal, row)" class="text-danger text-center" [ngbTooltip]="'CLOSE_ROUND' | translate" placement="left">
                        <i [data-feather]="'lock'" size="19"></i>
                      </span>
                    </button>
                    <button *ngIf="!!row.closed && !currentCommission.closed" class="bg-transparent border-0 text-secondary">
                      <span (click)="openModalCloseRound(closeRoundModal, row)" class="text-success text-center" [ngbTooltip]="'OPEN_ORDER' | translate" placement="left">
                        <i [data-feather]="'unlock'" size="19"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
    <!--ECONOMIC DETAIL SECTION-->
    <section class="col-12" id="section3" *ngIf="economicList && economicList.length > 0 && _authService.hasCapability('show_commission_economics')">
      <!--Desktop Economic-->
      <div class="card" [ngClass]="activeTab === 'economic' ? 'active' : ''" *ngIf="_utilService.isDesktop">
        <!--TITLE-->
        <div class="card-title px-2 mb-0" (click)="changeTab('economic')">
          <h3>{{ "ECONOMIC_DETAIL" | translate }}</h3>
        </div>
        <div [ngClass]="activeTab === 'economic' ? 'card-body pb-0 px-0' : 'd-none'">
          <div class="d-flex p-1 data-header">
            <div class="flex-basis-5"></div>
            <div class="flex-basis-10">
              {{ "MONTH" | translate | uppercase }}
            </div>
            <div class="flex-basis-10">
              {{ "ROUND" | translate | uppercase }}
            </div>
            <div class="flex-basis-15">
              {{ "ESTIMATED_COST" | translate | uppercase }}
            </div>
            <div class="flex-basis-15">
              {{ "EFFECTIVE_COST" | translate | uppercase }}
            </div>
            <div class="flex-basis-15">
              {{ "ESTIMATED_REVENUE" | translate | uppercase }}
            </div>
            <div class="flex-basis-15">
              {{ "EFFECTIVE_REVENUE" | translate | uppercase }}
            </div>
            <div class="flex-basis-10">
              {{ "EURO_MARGIN" | translate | uppercase }}
            </div>
            <div class="flex-basis-5">
              {{ "PERCENTAGE_MARGIN" | translate | uppercase }}
            </div>
          </div>
          <div class="mx-0 data-row cursor-pointer {{ row.classStyle === 'grey' ? 'bg-light-secondary' : null }}" *ngFor="let row of economicList; let i = index">
            <div class="row px-1" (click)="openEconomicDetail(i)">
              <div class="flex-basis-5 text-center" [ngbTooltip]="'OPEN_DETAIL' | translate">
                <i size="14" [data-feather]="'eye'"></i>
              </div>
              <div class="flex-basis-10 font-weight-bold">{{ row.month ? row.month : "-" }}</div>
              <div class="flex-basis-10">
                <span class="font-weight-bold">{{ row.progressive_id ? row.progressive_id : "-" }}</span>
              </div>
              <div class="flex-basis-15">{{ row.estimated_cost ? row.estimated_cost : "-" }} €</div>
              <div class="flex-basis-15">{{ row.real_cost ? row.real_cost : "-" }} €</div>
              <div class="flex-basis-15">{{ row.estimated_revenue ? row.estimated_revenue : "-" }} €</div>
              <div class="flex-basis-15">{{ row.real_profit ? row.real_profit : "-" }} €</div>
              <div class="flex-basis-10">{{ row.euro_margin ? row.euro_margin : "-" }} €</div>
              <div class="flex-basis-5">{{ row.percentage_margin ? row.percentage_margin : "-" }} %</div>
            </div>
            <!--Detail for each product-->
            <div class="col-12 px-0" *ngIf="row.open_modal">
              <div class="d-flex p-0 pt-05 pb-05 border-bottom detail-row-datatable" *ngFor="let product of row.products_details">
                <div class="flex-basis-20 ml-2 d-flex align-items-center">
                  <a [routerLink]="'/dashboard/product/' + product.product_id" target="_blank">{{ product.product_name ? product.product_name : "-" }}</a
                  ><span
                    *ngIf="product.commissions_number && product.commissions_number > 1"
                    class="commission-number"
                    [ngbTooltip]="('EMPLOYEEE_HAS_COMMISSION_NUMBER' | translate) + product.commissions_number + ('EMPLOYEEE_HAS_COMMISSION_NUMBER_SECOND' | translate)"
                    >{{ product.commissions_number }}</span
                  >
                </div>
                <div class="flex-basis-15">{{ product.estimated_cost ? product.estimated_cost : "0.00" }} €</div>
                <div class="flex-basis-15">{{ product.real_cost ? product.real_cost : "-" }} €</div>
                <div class="flex-basis-15">{{ product.estimated_revenue ? product.estimated_revenue : "-" }} €</div>
                <div class="flex-basis-15">{{ product.real_profit ? product.real_profit : "-" }} €</div>
                <div class="flex-basis-10">{{ product.euro_margin ? product.euro_margin : "-" }} €</div>
                <div class="flex-basis-5">{{ product.percentage_margin ? product.percentage_margin : "-" }} %</div>
              </div>
            </div>
          </div>
          <div class="row mx-1 mt-1 border-top data-row">
            <div class="flex-basis-20 text-center ml-2 font-weight-bold">{{ "TOTAL" | translate }}:</div>
            <div class="flex-basis-15">
              <span class="font-weight-bold">{{ total_estimated_cost }} €</span>
            </div>
            <div class="flex-basis-15">
              <span class="font-weight-bold">{{ total_real_cost }} €</span>
            </div>
            <div class="flex-basis-15">
              <span class="font-weight-bold">{{ total_estimated_revenue }} €</span>
            </div>
            <div class="flex-basis-15">
              <span class="font-weight-bold">{{ total_real_profit }} €</span>
            </div>
            <div class="flex-basis-10">
              <span class="font-weight-bold">{{ total_margin_euro }} €</span>
            </div>
            <div class="flex-basis-5">
              <span class="font-weight-bold">{{ total_margin_percentage }} %</span>
            </div>
          </div>
        </div>
      </div>
      <!--Mobile Economic-->
      <div class="card" [ngClass]="activeTab === 'economic' ? 'active' : ''" *ngIf="_utilService.isTablet || _utilService.isMobile">
        <!--TITLE-->
        <div class="card-title px-2 mb-0" (click)="changeTab('economic')">
          <h3>{{ "ECONOMIC_DETAIL" | translate }}</h3>
        </div>
        <div [ngClass]="activeTab === 'economic' ? 'card-body pb-0 px-0' : 'd-none'">
          <div class="col-12 p-1 data-header">
            {{ "MONTH" | translate | uppercase }}
          </div>
          <div class="row py-1 mx-0 {{ row.classStyle == 'grey' ? 'bg-light-secondary' : null }}" *ngFor="let row of economicList; let i = index">
            <div class="col-12">
              <span class="font-weight-bold">{{ "MONTH" | translate | titlecase }}: </span>
              <span>{{ row.month ? row.month : "-" }}</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">{{ "ROUND" | translate }}: </span>
              <span>{{ row.progressive_id ? row.progressive_id : "-" }}</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">{{ "ESTIMATED_COST" | translate }}: </span>
              <span>{{ row.estimated_cost ? row.estimated_cost : "0.00" }} €</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">{{ "EFFECTIVE_COST" | translate }}: </span>
              <span>{{ row.real_cost ? row.real_cost : "-" }} €</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">{{ "ESTIMATED_REVENUE" | translate }}: </span>
              <span>{{ row.estimated_revenue ? row.estimated_revenue : "-" }} €</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">{{ "EFFECTIVE_REVENUE" | translate }}: </span>
              <span>{{ row.real_profit ? row.real_profit : "-" }} €</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">{{ "EURO_MARGIN" | translate }}: </span>
              <span>{{ row.euro_margin ? row.euro_margin : "-" }} €</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">{{ "PERCENTAGE_MARGIN" | translate }}: </span>
              <span>{{ row.percentage_margin ? row.percentage_margin : "-" }} %</span>
            </div>
            <div class="col-12 text-center mb-1">
              <button (click)="openEconomicDetail(i)" class="btn btn-sm btn-outline-primary">{{ "OPEN_DETAIL" | translate }}</button>
            </div>
            <!--Detail for each product-->
            <div *ngIf="row.open_modal">
              <div class="row border-bottom py-1 px-0 mx-1 detail-row-datatable" *ngFor="let product of row.products_details">
                <div class="col-12 d-flex align-items-center">
                  <span class="font-weight-bold">{{ "PRODUCT" | translate }}: </span>
                  <span>{{ product.product_name ? product.product_name : "-" }}</span
                  ><span
                    *ngIf="product.commissions_number && product.commissions_number > 1"
                    class="commission-number"
                    [ngbTooltip]="('EMPLOYEEE_HAS_COMMISSION_NUMBER' | translate) + product.commissions_number + ('EMPLOYEEE_HAS_COMMISSION_NUMBER_SECOND' | translate)"
                    >{{ product.commissions_number }}</span
                  >
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "ESTIMATED_COST" | translate }}: </span>
                  <span>{{ product.estimated_cost ? product.estimated_cost : "-" }} €</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "EFFECTIVE_COST" | translate }}: </span>
                  <span>{{ product.real_cost ? product.real_cost : "-" }} €</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "ESTIMATED_REVENUE" | translate }}: </span>
                  <span>{{ product.estimated_revenue ? product.estimated_revenue : "-" }} €</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "EFFECTIVE_REVENUE" | translate }}: </span>
                  <span>{{ product.real_profit ? product.real_profit : "-" }} €</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "EURO_MARGIN" | translate }}: </span>
                  <span>{{ product.euro_margin ? product.euro_margin : "-" }} €</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "PERCENTAGE_MARGIN" | translate }}: </span>
                  <span>{{ product.percentage_margin ? product.percentage_margin : "-" }} %</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div [ngClass]="activeTab === 'economic' ? 'col-12' : 'd-none'">
          <div>
            <span class="font-weight-bold">{{ "TOTAL_ABBREVIATION" | translate }} {{ "ESTIMATED_COST" | translate }}: </span>
            <span class="font-weight-bold">{{ total_estimated_cost }} €</span>
          </div>
          <div>
            <span class="font-weight-bold">{{ "TOTAL_ABBREVIATION" | translate }} {{ "EFFECTIVE_COST" | translate }}: </span>
            <span class="font-weight-bold">{{ total_real_cost }} €</span>
          </div>
          <div>
            <span class="font-weight-bold">{{ "TOTAL_ABBREVIATION" | translate }} {{ "ESTIMATED_REVENUE" | translate }}: </span>
            <span class="font-weight-bold">{{ total_estimated_revenue }} €</span>
          </div>
          <div>
            <span class="font-weight-bold">{{ "TOTAL_ABBREVIATION" | translate }} {{ "EFFECTIVE_REVENUE" | translate }}: </span>
            <span class="font-weight-bold">{{ total_real_profit }} €</span>
          </div>
          <div>
            <span class="font-weight-bold">{{ "TOTAL_ABBREVIATION" | translate }} {{ "EURO_MARGIN" | translate }}: </span>
            <span class="font-weight-bold">{{ total_margin_euro }} €</span>
          </div>
          <div>
            <span class="font-weight-bold">{{ "TOTAL_ABBREVIATION" | translate }} {{ "PERCENTAGE_MARGIN" | translate }}: </span>
            <span class="font-weight-bold">{{ total_margin_percentage }} %</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<!-- Modal Detail Order -->
<ng-template #detailOrder let-modal>
  <form [formGroup]="formGroupOrder">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modalClose()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <div class="d-flex align-items-center mb-1">
        <h3 class="mb-0 mr-075" *ngIf="selectedOrder">{{ "DETAIL_ROUND" | translate }} {{ selectedOrder?.progressive_id ? selectedOrder.progressive_id : null }}</h3>
        <h3 class="mb-0 mr-075" *ngIf="!selectedOrder">{{ "DETAIL_NEW_ROUND" | translate }}</h3>
        <span class="badge badge-pill badge-{{ selectedOrder?.status_order.color }}" *ngIf="editModeOrder">
          {{ selectedOrder?.status_order.label }}
        </span>
      </div>
      <div class="row">
        <div class="form-group col-xl-4 col-12">
          <div class="d-flex justify-content-between">
            <label [for]="'deal_id'">{{ "DEAL" | translate }}<sup class="text-danger">*</sup></label>
            <a class="font-small-3" target="_blank" [routerLink]="'/dashboard/deals/edit/' + selectedDeal.id" *ngIf="selectedDeal">{{ "VIEW_DEAL" | translate }}</a>
          </div>
          <ng-select
            id="deal_id"
            bindLabel="complete_name"
            bindValue="id"
            formControlName="deal_id"
            [readonly]="dealId || !!selectedOrder"
            [multiple]="false"
            [searchable]="true"
            [closeOnSelect]="true"
            (change)="selectDeal()"
            [clearable]="false"
            [openOnEnter]="false"
            [virtualScroll]="true"
            [items]="dealsFilteredList"
          ></ng-select>
        </div>
        <div class="form-group col-xl-4 col-12" *ngIf="selectedDeal">
          <label [for]="'order_number'">{{ "ORDER_NUMBER" | translate }}</label>
          <input formControlName="order_number" name="order_number" type="text" [id]="'order_number'" maxlength="100" class="form-control" />
        </div>
        <div class="form-group col-xl-4 col-12" *ngIf="selectedDeal">
          <label [for]="'order_date'">{{ "ORDER_DATE" | translate }}</label>
          <app-datepickr id="order_date" [defaultDate]="formGroupOrder.value.order_date" (onSelect)="takeDate($event, 'order_date')"></app-datepickr>
        </div>
        <div class="form-group col-12" *ngIf="selectedDeal">
          <label [for]="'order_description'">{{ "ORDER_DESCRIPTION" | translate }}</label>
          <input formControlName="order_description" name="order_description" type="text" [id]="'description'" class="form-control {{ fieldHasErrors('order_description') ? 'is-invalid' : '' }}" />
          <div class="invalid-feedback" *ngIf="formGroupOrder.controls?.order_description?.errors?.maxlength">
            {{ "ERRORS.DESCRIPTION_MAX_LENGTH" | translate }}
          </div>
        </div>
        <div class="form-group col-xl-3 col-12" *ngIf="selectedDeal">
          <label for="type">{{ "TYPE_ORDER" | translate }}</label>
          <ng-select id="type" [ngModelOptions]="{ standalone: true }" (change)="changeTypeDeal()" [(ngModel)]="typeDeal" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
            <ng-option value="Product">{{ "PRODUCT" | translate }}</ng-option>
          </ng-select>
        </div>
        <div class="form-group col-xl-3 col-12" *ngIf="selectedDeal">
          <label [for]="'from'">{{ "FROM" | translate }}<sup class="text-danger">*</sup></label>
          <app-datepickr
            id="from"
            [isReadOnly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0"
            [defaultDate]="formGroupOrder.value.from"
            (onSelect)="takeDate($event, 'from'); calculateTrancheNumberAndFrequency()"
          ></app-datepickr>
        </div>
        <div class="form-group col-xl-3 col-12" *ngIf="selectedDeal">
          <label [for]="'to'">{{ "TO" | translate }}<sup class="text-danger">*</sup></label>
          <app-datepickr
            id="to"
            [isReadOnly]="(selectedOrder?.status_order.status && selectedOrder?.status_order.status === 2) || (selectedOrder?.status_order.status && selectedOrder?.status_order.status === 3)"
            [defaultDate]="formGroupOrder.value.to"
            (onSelect)="takeDate($event, 'to'); calculateTrancheNumberAndFrequency()"
          ></app-datepickr>
        </div>
        <div class="form-group col-xl-3 col-12" *ngIf="selectedDeal">
          <div class="d-flex flex-sm-column flex-md-row justify-content-md-between align-items-md-center">
            <label [for]="'capacity'">{{ "CAPACITY" | translate }}<sup class="text-danger">*</sup></label>
            <label
              class="text-danger font-small-2"
              [for]="'capacity'"
              *ngIf="selectedDeal?.deal_document?.table[0]?.total_discounted_deal && selectedDeal?.deal_document?.table[0]?.total_discounted_deal !== selectedDeal?.deal_document?.table[0]?.total_deal"
            >
              {{ "DISCOUNT_PROPOSED_TO_CUSTOMER" | translate }}: {{ selectedDeal?.deal_document?.table[0]?.total_discounted_deal }} € {{ "NOT_DISCOUNTED" | translate }}:
              {{ selectedDeal?.deal_document?.table[0]?.total_deal }} €
            </label>
          </div>
          <input (change)="formatMoneyValue('capacity')" formControlName="capacity" name="capacity" type="text" [id]="'capacity'" class="form-control {{ fieldHasErrors('capacity') ? 'is-invalid' : '' }}" />
          <div class="invalid-feedback">{{ "ERRORS.INSERT_CAPACITY" | translate }}</div>
          <div *ngIf="residualFromPrevOrders" class="font-small-3">{{ "RESIDUAL_PREV_ROUNDS" | translate }} {{ _utilService.addDotsToNumber(residualFromPrevOrders) }} €</div>
        </div>

        <div class="form-group col-xl-6 col-12" *ngIf="selectedDeal">
          <label [for]="'billing_frequency'">{{ "BILLING_FREQUENCY" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select
            [multiple]="false"
            [searchable]="true"
            [closeOnSelect]="true"
            [clearable]="false"
            [openOnEnter]="false"
            [virtualScroll]="true"
            class="{{ fieldHasErrors('billing_frequency') ? 'is-invalid' : '' }}"
            id="billing_frequency"
            bindLabel="name"
            (change)="calculateTrancheNumberAndFrequency()"
            bindValue="id"
            formControlName="billing_frequency"
            [items]="billingFrequencyList"
            [readonly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0"
          ></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_BILLING_FREQUENCY" | translate }}</div>
        </div>
        <div class="form-group col-xl-6 col-12" *ngIf="selectedDeal">
          <label [for]="'payment_terms'">{{ "PAYAMENT_TERMS" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select
            [multiple]="false"
            [searchable]="true"
            [closeOnSelect]="true"
            [clearable]="false"
            [openOnEnter]="false"
            [virtualScroll]="true"
            class="{{ fieldHasErrors('payment_terms') ? 'is-invalid' : '' }}"
            id="payment_terms"
            bindLabel="name"
            bindValue="id"
            formControlName="payment_terms"
            [items]="paymentsTermsList"
            [readonly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0"
          ></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_PAYMENT_TERMS" | translate }}</div>
        </div>
        <div class="form-group col-xl-6" *ngIf="selectedDeal">
          <label [for]="'invoice_type'">{{ "INVOICE_TYPE" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select
            [multiple]="false"
            [searchable]="true"
            [closeOnSelect]="true"
            [clearable]="false"
            [openOnEnter]="false"
            [virtualScroll]="true"
            class="{{ fieldHasErrors('invoice_type') ? 'is-invalid' : '' }}"
            id="invoice_type"
            bindLabel="name"
            bindValue="id"
            formControlName="invoice_type"
            [items]="invoiceTypeList"
            [readonly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0"
          ></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_INVOICE_TYPE" | translate }}</div>
        </div>
        <div class="form-group col-xl-6" *ngIf="selectedDeal">
          <label [for]="'payment_measure_unit'">{{ "PAYMENT_MEASURE_UNIT" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select
            [multiple]="false"
            [searchable]="true"
            [closeOnSelect]="true"
            [clearable]="false"
            [openOnEnter]="false"
            [virtualScroll]="true"
            class="{{ fieldHasErrors('payment_measure_unit') ? 'is-invalid' : '' }}"
            id="payment_measure_unit"
            bindLabel="name"
            bindValue="id"
            formControlName="payment_measure_unit"
            [items]="paymentMeasureUnitList"
            [readonly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0"
          ></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_PAYMENT_MEASURE_UNIT" | translate }}</div>
        </div>
        <div class="form-group ml-1 custom-control custom-control-primary custom-switch" *ngIf="selectedDeal" [ngClass.sm]="'col-12 ml-2 mb-1'">
          <small class="mr-025">{{ "CUSTOMER_APPROVAL" | translate }}</small>
          <input
            type="checkbox"
            class="custom-control-input"
            id="customerApproval"
            formControlName="client_approval"
            (click)="((selectedOrder?.status_order.status && selectedOrder?.status_order.status === 2) || (selectedOrder?.status_order.status && selectedOrder?.status_order.status === 3) ? false : null)"
          />
          <label class="custom-control-label" for="customerApproval"> </label>
        </div>
      </div>
      <div class="row mt-1" *ngIf="selectedDeal">
        <div class="col-12">
          <h3>{{ "PRODUCTS_DETAIL" | translate }}</h3>
        </div>
        <div class="form-group col-xl-6 col-12 d-flex align-items-center">
          <div class="cursor-pointer mt-1 mr-075" *ngIf="editModeOrder && productsArray && productsArray.length > 0">
            <span class="text-primary" [ngbTooltip]="'OPEN_DETAIL_PRODUCT' | translate" (click)="openDetailProduct = !openDetailProduct" *ngIf="!openDetailProduct"><i [data-feather]="'eye'" size="20"></i></span>
            <span class="text-primary" [ngbTooltip]="'CLOSE_DETAIL_PRODUCT' | translate" (click)="openDetailProduct = !openDetailProduct" *ngIf="openDetailProduct"><i [data-feather]="'eye-off'" size="20"></i></span>
          </div>
          <div class="d-flex flex-column w-100">
            <label for="product">{{ "PRODUCTS" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              id="product"
              bindLabel="name"
              bindValue="id"
              formControlName="products_ids"
              [hideSelected]="true"
              [multiple]="true"
              [searchable]="true"
              [closeOnSelect]="true"
              [readonly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0"
              class="{{ fieldHasErrors('products_ids') ? 'is-invalid' : '' }}"
              (change)="manageRow()"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="false"
              [items]="productList"
            ></ng-select>
            <div class="invalid-feedback">{{ "ERRORS.PRODUCTS_REQUIRED" | translate }}</div>
          </div>
        </div>
        <div class="form-group col-xl-3 col-12" *ngIf="typeDeal && typeDeal === 'Product'">
          <label [for]="'tranche_number'">{{ "TRANCHE_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
          <input formControlName="tranche_number" name="tranche_number" [readonly]="true" type="number" [id]="'tranche_number'" class="form-control {{ fieldHasErrors('tranche_number') ? 'is-invalid' : '' }}" />
          <div class="invalid-feedback">{{ "ERRORS.INSERT_TRANCHE_NUMBER" | translate }}</div>
        </div>
        <div class="form-group col-xl-3 col-12" *ngIf="typeDeal && typeDeal === 'Product'">
          <label [for]="'tranche_import'">{{ "TRANCHE_IMPORT" | translate }}<sup class="text-danger">*</sup></label>
          <input
            (change)="formatMoneyValue('tranche_import')"
            formControlName="tranche_import"
            name="tranche_import"
            type="text"
            [id]="'tranche_import'"
            [readonly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0"
            class="form-control {{ fieldHasErrors('tranche_import') ? 'is-invalid' : '' }}"
          />
          <div class="invalid-feedback">{{ "ERRORS.INSERT_TRANCHE_IMPORT" | translate }}</div>
        </div>
        <div *ngIf="openDetailProduct" class="col-12" [@inOutAnimation]>
          <div class="row">
            <div class="col-12" *ngIf="typeDeal && typeDeal === 'Product'">
              <div class="row" *ngFor="let row of productsArray; let i = index">
                <div class="form-group col-xl-3 col-12">
                  <label [for]="'product_id' + i">{{ "PRODUCT" | translate }}<sup class="text-danger">*</sup></label>
                  <ng-select
                    [id]="'product_id' + i"
                    bindLabel="name"
                    bindValue="id"
                    [(ngModel)]="row.product_id"
                    [readonly]="true"
                    [multiple]="false"
                    [searchable]="true"
                    [closeOnSelect]="true"
                    [ngModelOptions]="{ standalone: true }"
                    [clearable]="false"
                    [openOnEnter]="false"
                    [virtualScroll]="true"
                    [items]="productList"
                  ></ng-select>
                </div>
                <div class="form-group col-xl-2 col-12">
                  <label [for]="'quantity_' + i">{{ "QUANTITY" | translate }}<sup class="text-danger">*</sup></label>
                  <input
                    [(ngModel)]="row.quantity"
                    name="quantity"
                    type="text"
                    [id]="'quantity_' + i"
                    [readonly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0"
                    class="form-control"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group col-xl-2 col-12">
                  <label [for]="'price_' + i">{{ "PRICE" | translate }}<sup class="text-danger">*</sup></label>
                  <input
                    (change)="formatPrice(i)"
                    [(ngModel)]="row.price"
                    name="price"
                    type="text"
                    [id]="'price_' + i"
                    class="form-control"
                    [ngModelOptions]="{ standalone: true }"
                    [readonly]="selectedOrder?.status_order.status && selectedOrder?.status_order.status !== 0"
                  />
                </div>
                <div class="form-group col-xl-2 col-12">
                  <label [for]="'tranche_number_product_' + i">{{ "TRANCHE_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
                  <input
                    [(ngModel)]="formGroupOrder.value.tranche_number"
                    name="tranche_number_product_"
                    type="text"
                    [id]="'tranche_number_product_' + i"
                    class="form-control"
                    [readonly]="true"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
                <div class="form-group col-xl-3 col-12">
                  <label [for]="'tranche_single_import_' + i">{{ "TRANCHE_IMPORT_PRODUCT" | translate }}<sup class="text-danger">*</sup></label>
                  <input
                    [(ngModel)]="row.tranche_single_import"
                    name="tranche_single_import"
                    [readonly]="true"
                    type="text"
                    [id]="'tranche_single_import_' + i"
                    class="form-control"
                    [ngModelOptions]="{ standalone: true }"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group col-12" *ngIf="selectedDeal">
          <label [for]="'description'">{{ "ROUND_DESCRIPTION" | translate }}</label>
          <textarea formControlName="description" name="description" type="text" [id]="'description'" class="form-control {{ fieldHasErrors('description') ? 'is-invalid' : '' }}"></textarea>
          <div class="invalid-feedback" *ngIf="formGroupOrder.controls?.description?.errors?.maxlength">
            {{ "ERRORS.DESCRIPTION_MAX_LENGTH" | translate }}
          </div>
        </div>
      </div>
      <!--File Section-->
      <div class="row mt-1" *ngIf="selectedDeal">
        <div class="col-xl-6 col-12" ngClass.xl="border-right" ngClass.md="mb-1" ngClass.sm="mb-1">
          <h3>{{ "DOCUMENT_ORDER" | translate }}</h3>
          <div class="row" *ngIf="order_document">
            <div class="col-12 mb-05">
              <span class="badge badge-light-success cursor-pointer px-1 pt-05 pb-05 mr-025" [ngbTooltip]="'VIEW' | translate" (click)="_utilService.getFile(order_document)">
                <span class="mr-025" [data-feather]="'file-text'" size="20"></span>
                <span class="font-small-4 font-weight-bold">{{ order_document_name }}</span>
              </span>
              <button type="button" class="btn border-0 px-0 text-danger" [ngbTooltip]="'DELETE' | translate" (click)="deleteDocument()">
                <span [data-feather]="'trash-2'" size="16"></span>
              </button>
            </div>
          </div>
          <div class="row" *ngIf="!order_document">
            <div class="col-10 d-flex justify-content-between align-items-center mb-05">
              <div>{{ "NO_ONE_DOCUMENT_UPLOADED" | translate }}</div>
            </div>
          </div>
          <div class="row" *ngIf="selectedOrder?.status_order !== 2 || !editModeOrder">
            <div class="col-xl-6 col-12">
              <div id="file-uploader" class="custom-file mt-1">
                <input class="custom-file-input" type="file" lang="it" id="file" [multiple]="false" (change)="addFileToList($any($event).target.files)" accept="application/pdf" />
                <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-1">
              <div class="d-flex align-items-center justify-content-between">
                <div *ngIf="files_list_obj.length > 0">
                  <button class="btn btn-outline-danger" (click)="resetFilesList()">{{ "RESET" | translate }}</button>
                </div>
              </div>
            </div>
            <div class="col-11 mt-3 border-top pt-1" *ngIf="files_list_obj.length > 0">
              <div *ngFor="let file of files_list_obj; let i = index" class="d-flex border-bottom mb-1 pb-1">
                <div class="flex-basis-60 d-flex align-items-center">
                  <div class="mr-05 cursor-pointer" (click)="removeFileFromList(i)" *ngIf="file.status === 0">
                    <i [data-feather]="'x'" class="text-danger" size="18"></i>
                  </div>
                  <div class="mt-025">{{ file.name }}</div>
                </div>
                <div class="flex-basis-20 text-right">{{ file.size }}</div>
              </div>
              <div>{{ "TOTAL" | translate }}: {{ files_list_obj.length }}</div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-12">
          <h3>{{ "ATTACHMENTS_ORDER" | translate }}</h3>
          <div class="row" *ngIf="selectedOrder && selectedOrder.order_attachments && selectedOrder.order_attachments.length > 0">
            <div class="col-12 d-flex align-items-center" *ngFor="let file of selectedOrder.order_attachments">
              <span class="badge badge-warning cursor-pointer mr-025" [ngbTooltip]="'VIEW' | translate" (click)="_utilService.getFile(file.url)"
                ><span class="mr-025" [data-feather]="'file-text'" size="16"></span>{{ file?.filename }}</span
              >
              <button type="button" class="btn border-0 px-0 text-danger" [ngbTooltip]="'DELETE' | translate" (click)="deleteAttachment(file.id)">
                <span [data-feather]="'trash-2'" size="16"></span>
              </button>
            </div>
          </div>
          <div class="row" *ngIf="!selectedOrder || !selectedOrder.order_attachments || (selectedOrder && selectedOrder.order_attachments && selectedOrder.order_attachments.length < 1)">
            <div class="col-10 d-flex justify-content-between align-items-center mb-05">
              <div>{{ "NO_ONE_DOCUMENT_UPLOADED" | translate }}</div>
            </div>
          </div>
          <div class="row" *ngIf="selectedOrder?.status_order !== 2 || !editModeOrder">
            <div class="col-xl-6 col-12">
              <div id="attachment-uploader" class="custom-file mt-1">
                <input class="custom-file-input" type="file" lang="it" id="attachment" [multiple]="true" (change)="addAttachmentToList($any($event).target.files)" accept="application/pdf" />
                <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-1">
              <div class="d-flex align-items-center justify-content-between">
                <div *ngIf="attachments_list_obj.length > 0">
                  <button class="btn btn-outline-danger" (click)="resetAttachmentsList()">{{ "RESET" | translate }}</button>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3 border-top pt-1" *ngIf="attachments_list_obj.length > 0">
              <div *ngFor="let file of attachments_list_obj; let i = index" class="d-flex border-bottom mb-1 pb-1">
                <div class="flex-basis-60 d-flex align-items-center">
                  <div class="mr-05 cursor-pointer" (click)="removeAttachmentFromList(i)" *ngIf="file.status === 0">
                    <i [data-feather]="'x'" class="text-danger" size="18"></i>
                  </div>
                  <div class="mt-025">{{ file.name }}</div>
                </div>
                <div class="flex-basis-20 text-right">{{ file.size }}</div>
              </div>
              <div>{{ "TOTAL" | translate }}: {{ attachments_list_obj.length }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center" *ngIf="(!editModeOrder && selectedDeal) || (selectedOrder && selectedOrder?.status_order !== 2)">
      <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="editModeOrder ? editOrder() : createOrder()">
        {{ "SAVE" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal Detail Order -->

<!-- note Close Commission Modal -->
<ng-template #closeCommissionModal let-modal>
  <div>
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "INSERT_NOTE" | translate }}</h3>
      <div class="form-group mb-1">
        <label for="rejectedNote2">{{ "NOTE" | translate }}<sup class="text-danger">*</sup></label>
        <textarea [(ngModel)]="closeMotivation" class="form-control" name="rejectedNote" id="rejectedNote2" cols="45" rows="3"></textarea>
      </div>
      <div class="form-group">
        <label [for]="'close_date'">{{ "FROM" | translate }}<sup class="text-danger">*</sup></label>
        <app-datepickr id="close_date" [defaultDate]="todayDate" (onSelect)="takeDate($event, 'close_date')"></app-datepickr>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button class="btn btn-outline-primary" (click)="modalClose()">{{ "BACK" | translate }}</button>
      <button [disabled]="!closeMotivation || closeMotivation.length < 5" (click)="closeCommission()" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- / note Close Commission Modal -->

<ng-template #roundConflictDecision let-modal>
  <div>
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "ALERT.ALERT_TITLE" | translate }}</h3>
      <div *ngIf="conflictRoundDetail">
        <p>{{ "ALERT.ALREADY_PRESENT_A_ROUND" | translate }}</p>
        <p>{{ "ORIGINAL_CLOUSURE_ROUND" | translate }}: {{ _utilService.formatDate(conflictRoundDetail.originalEndDate) }}</p>
        <p>{{ "NEW_CLOUSURE_ROUND" | translate }}: {{ _utilService.formatDate(conflictRoundDetail.newEndDate) }}</p>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button *ngIf="!!conflictRoundDetail" class="btn btn-outline-primary" (click)="modal.dismiss('Cross click')">
        {{ "CANCEL" | translate }}
      </button>
      <button *ngIf="!!conflictRoundDetail" (click)="changeEndDateRoundBefore(); modal.dismiss('Cross click')" class="btn btn-primary w-150" rippleEffect>
        {{ "ACCEPT_NEW_DATE" | translate }}
      </button>
    </div>
  </div>
</ng-template>

<!-- Close Round Modal -->
<ng-template #closeRoundModal let-modal>
  <div>
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "CLOSE_ROUND" | translate }}</h3>
      <div class="form-group mb-1">
        <label for="closeRoundDate">{{ "FROM" | translate }}<sup class="text-danger">*</sup></label>
        <app-datepickr id="closeRoundDate" [defaultDate]="closeRoundDate" (onSelect)="takeDate($event, 'closeRoundDate')" [isInvalid]="!closeRoundDate && showErrors"></app-datepickr>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button class="btn btn-outline-primary" (click)="modalClose()">{{ "BACK" | translate }}</button>
      <button [disabled]="!closeRoundDate" (click)="manageStatusOrder()" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- / Close Round Modal -->
